const typeValidate = (file, supportedTypes) => {
  if (!supportedTypes.length) return true;
  return supportedTypes.includes(file.name.toLowerCase().split('.').pop())
}
const sizeValidate = (file, supportedSizeMb) => {
  return mbToBytes(supportedSizeMb) >= file.size
}
const mbToBytes = (mb) => {
  return mb * 1048576
}
const uniqueId = () => {
  return (Math.random() * 100000).toString()
}

export {
  typeValidate,
  sizeValidate,
  mbToBytes,
  uniqueId
}
